import mFPassword from "./login/forgot-password.svg";
import mProfile from "./login/profile.svg";
import mLoader from "./others/Loader.svg";
import mLogin from "../images/login.png";
import mStock from "./login/stock.svg";
import mSales from "./login/sales.svg";

// Login Slider
export const ProfileSVG = mProfile;
export const FPassword = mFPassword;
export const LoginSVG = mLogin;
export const StockSVG = mStock;
export const SalesSVG = mSales;

// others
export const LoaderSVG = mLoader;
